module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"順位":"順位","平均歩数":"平均歩数","歩":"歩","位":"位"},"en":{"順位":"Ranking","平均歩数":"Average steps","歩":"steps","位":" "}}')
  delete Component.options._Ctor
}
